module.exports = __webpack_public_path__ + "static/media/case_07.17c849fd.jpg";